import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
export function PainPoints() {
  return <section className="py-24 bg-neutral-50" data-id="element-98">
      <div className="container mx-auto px-6" data-id="element-99">
        <div className="max-w-5xl mx-auto" data-id="element-100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-101">
            {/* Problem */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-102">
              <h2 className="text-3xl font-normal tracking-tight text-neutral-900 mb-8" data-id="element-103">
                Самостійне вирішення <br data-id="element-104" />
                <span className="font-semibold" data-id="element-105">це завжди стрес</span>
              </h2>
              <ul className="space-y-6" data-id="element-106">
                {['Емоційний тиск та неприємні зустрічі з колишнім партнером', 'Бюрократія, черги в судах та незрозумілі документи', 'Ризик помилок у позовах, що затягує процес на місяці', 'Несправедливий поділ майна через незнання законів'].map((text, i) => <li key={i} className="flex items-start gap-4 text-neutral-600" data-id="element-107">
                    <AlertCircle className="w-6 h-6 text-neutral-400 shrink-0 mt-0.5" data-id="element-108" />
                    <span className="leading-relaxed" data-id="element-109">{text}</span>
                  </li>)}
              </ul>
            </motion.div>

            {/* Solution */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white p-10 rounded-2xl shadow-sm border border-neutral-100" data-id="element-110">
              <h2 className="text-3xl font-normal tracking-tight text-neutral-900 mb-8" data-id="element-111">
                З адвокатом <br data-id="element-112" />
                <span className="font-semibold" data-id="element-113">це спокій та результат</span>
              </h2>
              <ul className="space-y-6" data-id="element-114">
                {['Жодних зустрічей — я веду переговори та суд замість вас', 'Всі документи готуються професійно та з першого разу', 'Процес проходить максимально швидко, наскільки дозволяє закон', 'Ваші майнові та батьківські права надійно захищені'].map((text, i) => <li key={i} className="flex items-start gap-4 text-neutral-900" data-id="element-115">
                    <CheckCircle2 className="w-6 h-6 text-neutral-900 shrink-0 mt-0.5" data-id="element-116" />
                    <span className="leading-relaxed font-medium" data-id="element-117">{text}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}